import i18next from 'i18next';
import { carregarSelect2 } from './carregarSelect2';
import { _URL_FORM, abrirFormCadastro, fecharFormCadastro, formatarSalario } from './helpers';
import { janelaAjuda } from './janelaAjuda';
import { progressoCurriculo } from './progresso';

export const objetivo = function (dadosPretensaoSalarial) {
    const $divPanel = '#panel-objetivo';
    const $panel = body.find($divPanel);
    const _excluir = function (id) {
        swal({
            title: i18next.t('objetivoRemoverItem'),
            html: i18next.t('objetivoRemoverItemDesc'),
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD6B55",
            confirmButtonText: i18next.t('btnSimRemover'),
            cancelButtonText: i18next.t('btnCancelar'),
            closeOnConfirm: true
        }, function () {
            window.global.loaderPanel.show($divPanel);
            $.ajax({
                type: "POST",
                url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/DeleteCargo',
                data: { id: id },
                cache: false,
                success: function (data) {
                    window.global.loaderPanel.hide($divPanel);
                    if (data.success == '0') {
                        swal("", data.error, "error");
                    } else {
                        toastr.success(i18next.t('objetivoRemoverSucesso'), '', { "closeButton": true });
                        $panel.find('#cargo-item-' + id).remove();
                        progressoCurriculo();
                    }
                },
                error: function () {
                    window.global.loaderPanel.show($divPanel);
                    swal("", i18next.t('erroServidor'), "error");
                }
            });
        });

    };
    const _listar = function (dadosPretensaoSalarial) {
        window.global.loaderPanel.show($divPanel);
        $.ajax({
            type: "GET",
            url: '/' + CULTURE_EMPREGARE + '/PainelCurriculoAntigo/GetObjetivo', cache: false,
            success: function (dados) {
                var htmlCargos = [], htmlPretensaoSalarial = "", htmlFinal = "", elementNull = document.getElementById("objetivo-null");

                if (dados != '' && (dados.areas.length > 0 || dadosPretensaoSalarial.pretensaoSalarialID > 0 || (dadosPretensaoSalarial.pretensaoSalarialMin > 0 && dadosPretensaoSalarial.pretensaoSalarialMax > 0))) {
                    for (var i = 0; i < dados.areas.length; i++) {
                        htmlCargos.push('<div class="btn btn-sm btn-label btn-label-default-outline btn-editar mt5 mr5" data-nome="' + dados.areas[i].Nome + '" data-id="' + dados.areas[i].ID + '" id="objetivo-item-' + dados.areas[i].ID + '">' + dados.areas[i].Nome + '</div>');

                    }
                    elementNull.className = 'hide';

                    htmlFinal = '<div class="container-pretensao"><h4 class="mt0"><b>' + i18next.t('objetivoPretensao') + '</b></h4>';

                    if (dadosPretensaoSalarial.moedaSigla && dadosPretensaoSalarial.pretensaoSalarialMin && dadosPretensaoSalarial.pretensaoSalarialMax) {
                        htmlFinal += `<p id="pretensao-salarial" data-moedaSigla="${dadosPretensaoSalarial.moedaSigla}">
                            <span id="pretensao-salarial-min" style="margin-right: 10px" data-pretensaoSalarialMin="${dadosPretensaoSalarial.pretensaoSalarialMin}">${i18next.t('objetivoDe')}: ${formatarSalario(dadosPretensaoSalarial.pretensaoSalarialMin, dadosPretensaoSalarial.moedaSigla)}  </span>
                            <span id="pretensao-salarial-max" data-pretensaoSalarialMax="${dadosPretensaoSalarial.pretensaoSalarialMax}"> ${i18next.t('objetivoAte')}:  ${formatarSalario(dadosPretensaoSalarial.pretensaoSalarialMax, dadosPretensaoSalarial.moedaSigla)} </span>
                        </p>`;
                    }
                    else
                        htmlFinal += '<p id="pretensao-salarial-selected" data-id="' + dadosPretensaoSalarial.pretensaoSalarialID + '">' + ((dadosPretensaoSalarial.pretensaoSalarialID === 0 || dadosPretensaoSalarial.pretensaoSalarialID == null) ? '<span class="alert alert-sm alert-warning cursor-pointer btn-editar"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('objetivoPretensaoNull') + ' </span>' : dadosPretensaoSalarial.pretensaoSalarial) + '</p>';

                    htmlFinal += '</div>';
                    htmlFinal += '<h4 class=""><b>' + i18next.t('objetivoArea') + '</b></h4><p>' + (dados.areas.length == 0 ? '<span class="alert alert-sm alert-warning cursor-pointer btn-editar"><i class="fa fa-exclamation-circle"></i> ' + i18next.t('objetivoAreaNull') + ' </span>' : htmlCargos.join('')) + '</p>';

                    document.getElementById('objetivo-lista').innerHTML = htmlFinal;
                    $panel.find('.btn-editar').on('click', function (e) {
                        _abrir(dadosPretensaoSalarial.salarioConvertidoEnum);
                        e.preventDefault();
                    });
                    $panel.find('.btn-add').removeClass('hide');

                } else {
                    elementNull.className = '';
                    document.getElementById('objetivo-lista').innerHTML = '';
                }
                window.global.loaderPanel.hide($divPanel);
            },
            error: function () {
                window.global.loaderPanel.hide($divPanel);
            }
        });


    };
    const _salvar = function () {
        var $form = $panel.find('#form-objetivo');

        window.global.loaderButton.show($form.find('button[type=submit]'));

        dadosPretensaoSalarial.pretensaoSalarial = $form.find("#pretensao-salarial option:selected").text();
        dadosPretensaoSalarial.pretensaoSalarialID = $form.find("#pretensao-salarial").val();
        dadosPretensaoSalarial.moedaSigla = $form.find(".select-moeda").val();
        dadosPretensaoSalarial.pretensaoSalarialMin = $form.find("#pretensao-salarial-input-min").val();
        dadosPretensaoSalarial.pretensaoSalarialMax = $form.find("#pretensao-salarial-input-max").val();

        $.ajax({
            type: "POST",
            url: $form.attr('action'), cache: false,
            data: $form.serialize(),
            success: function (data) {
                if (data.success == 1) {
                    toastr.success(i18next.t('objetivoSalvo'), '', { "closeButton": true });
                    _listar(dadosPretensaoSalarial);
                    progressoCurriculo();
                    _fechar();
                }
                else {
                    window.global.loaderButton.hide($form.find('button[type=submit]'));
                    swal("", data.error, "error");
                }

            },
            error: function () {
                window.global.loaderButton.hide($form.find('button[type=submit]'));
                swal("", i18next.t('erroServidor'), "error");
            }
        });
    };
    const _fechar = function () {
        document.getElementById('objetivo-contentform').innerHTML = '';
        goToByScroll($divPanel);
        fecharFormCadastro();
    };
    const _abrir = function (salarioAntigoPreencherNovo) {
        goToByScroll($divPanel);

        window.global.loaderFull.show();
        //window.global.loaderPanel.show($divPanel);
        var formulario = $panel.find('#objetivo-contentform');
        abrirFormCadastro();
        formulario.load(_URL_FORM + "Objetivo?v=2", function () {

            formulario.find('.close-panel').on('click', function (e) {
                _fechar();
                e.preventDefault();
            });
            formulario.find('#form-objetivo').on('submit', function (e) {
                e.preventDefault();

                _salvar();
            });
            var dataCargos = [];

            carregarSelect2().then(function () {
                formulario.find('#objetivo-area').select2({
                    maximumSelectionLength: 3,
                    placeholder: i18next.t('objetivoAreaSelecione'),
                });
            });

            formulario.find('#pretensao-salarial').val($panel.find('#pretensao-salarial-selected').attr('data-id'));

            const moedaSiglaUpdate = $panel.find('#pretensao-salarial').attr('data-moedasigla');
            const pretencaoMinValor = $panel.find('#pretensao-salarial-min').attr('data-pretensaosalarialmin');
            const pretencaoMaxValor = $panel.find('#pretensao-salarial-max').attr('data-pretensaosalarialmax');

            formulario.find('.select-moeda').val((moedaSiglaUpdate && moedaSiglaUpdate != "") ? moedaSiglaUpdate : "R$");
            formulario.find('#pretensao-salarial-input-min').val((pretencaoMinValor && pretencaoMinValor != "") ? pretencaoMinValor : salarioAntigoPreencherNovo);
            formulario.find('#pretensao-salarial-input-max').val((pretencaoMaxValor && pretencaoMaxValor != "") ? pretencaoMaxValor : salarioAntigoPreencherNovo);

            var htmlSelect = [], selectedValues = [];
            $panel.find('#objetivo-lista').find('div').each(function (index) {
                var _this = $(this);
                selectedValues.push(_this.attr('data-id'));
            });
            formulario.find('#objetivo-area').val(selectedValues).trigger("change");

            janelaAjuda(formulario);

            const selectsMoeda = document.querySelectorAll('.select-moeda');

            selectsMoeda.forEach(select => {
                const selectEspelho = document.getElementById(select.id == "moeda-salario-max" ? "moeda-salario-min" : "moeda-salario-max");
                select.addEventListener('change', () => selectEspelho.value = select.value);
            });

            // impede zeros a esquerda na pretensao salarial
            formulario.find('#pretensao-salarial-input-min, #pretensao-salarial-input-max').on('input', function () {
                this.value = this.value.replace(/^0+(?=\d)/, '');
            });

            setTimeout(() => {
                window.global.loaderFull.hide();
            }, 1000);
            // window.global.loaderPanel.hide($divPanel);
        });


    };

    const init = function () {
        _listar(dadosPretensaoSalarial);

        $panel.find('.btn-add').on('click', function (e) {
            _abrir(dadosPretensaoSalarial.salarioConvertidoEnum);
            e.preventDefault();
        });
    }

    return init();
};



